import { c } from "react/compiler-runtime";
import { jsx } from "react/jsx-runtime";
import { Menu } from "@base-ui/react/menu";
//#region src/components/menu/menu.trigger.tsx
/** A button-like anchor that opens its Menu. */
var MenuTrigger = (t0) => {
	const $ = c(8);
	let children;
	let t1;
	let triggerProps;
	if ($[0] !== t0) {
		const { children: t2, render, ...t3 } = t0;
		children = t2;
		triggerProps = t3;
		t1 = typeof render === "function" ? (props, state) => render(props, {
			disabled: state.disabled,
			open: state.open
		}) : render;
		$[0] = t0;
		$[1] = children;
		$[2] = t1;
		$[3] = triggerProps;
	} else {
		children = $[1];
		t1 = $[2];
		triggerProps = $[3];
	}
	const resolvedRender = t1;
	let t2;
	if ($[4] !== children || $[5] !== resolvedRender || $[6] !== triggerProps) {
		t2 = /* @__PURE__ */ jsx(Menu.Trigger, {
			...triggerProps,
			render: resolvedRender,
			children
		});
		$[4] = children;
		$[5] = resolvedRender;
		$[6] = triggerProps;
		$[7] = t2;
	} else t2 = $[7];
	return t2;
};
//#endregion
export { MenuTrigger };
